import email from '../../../assets/email-icon.svg';
import phone from '../../../assets/phone.svg';

const contactInfo = [
  {
    name: 'e-mail',
    title: 'welcome.cardTitle',
    icon: email,
    type: {
      emailAddress: 'customercare.feller@feller.ch',
      subject: '',
    },
  },
  {
    name: 'customer service',
    title: '0844 72 73 74',
    text: 'welcome.customerService',
    icon: phone,
    type: {
      phoneNumber: '+41844727374',
    },
  },
];

export default contactInfo;
